import { createFileRoute } from '@tanstack/react-router';

import { ProjectsListPage } from '@/features/projects/ProjectsListPage';

export const Route = createFileRoute('/admin/_app/projects/')({
  component: ProjectsListPage,
});
